import i18next from "i18next";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

type EditorI18nOptions = Record<string, string | number | boolean | undefined>;

export function editorT(key: string, options?: EditorI18nOptions) {
  return i18next.t(key, { ns: "editor", ...options });
}

export function useEditorI18n() {
  const { t } = useTranslation("editor");

  return useCallback(
    (key: string, options?: EditorI18nOptions) => t(key, options),
    [t],
  );
}
